import Header from './Header';
import Footer from './Footer';
import MobileCTA from './MobileCTA';
import AccessibilityWidget from '../AccessibilityWidget';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col font-body">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <MobileCTA />
      <AccessibilityWidget />
    </div>
  );
};

export default Layout;
